import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Button, ButtonGroup, Container, Flex } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "wouter";

import { useScenario } from "@nens/ldo/api-v1";
import { ActionButtons, Breadcrumbs, ScenarioRastersMap } from "@nens/ldo/components";

interface ScenarioDetailPageProps {
  scenarioIdParam: string;
}

export default function ScenarioDetailMap({ scenarioIdParam }: ScenarioDetailPageProps) {
  const intl = useIntl();
  const setLocation = useLocation()[1];
  const scenarioId = parseInt(scenarioIdParam);
  const scenarioResponse = useScenario(scenarioId);

  const scenario = scenarioResponse.data;

  if (Number.isNaN(scenarioId) || scenarioResponse.isError) {
    setLocation("/scenarios");
  }

  if (!scenario) return null;

  return (
    <Box w="100%">
      <Breadcrumbs
        crumbs={[
          { label: intl.formatMessage({ id: "pages.home", defaultMessage: "Home" }), href: "/" },
          {
            label: intl.formatMessage({ id: "pages.scenarios", defaultMessage: "Scenarios" }),
            href: "/scenarios",
          },
          {
            label: scenarioResponse.isSuccess
              ? scenarioResponse.data.name
              : intl.formatMessage({ id: "pages.scenario", defaultMessage: "Scenario" }),
            href: `/scenarios/${scenarioId}`,
          },
          {
            label: intl.formatMessage({ id: "pages.scenario.map", defaultMessage: "Map" }),
            href: `/scenarios/${scenarioId}/map`,
          },
        ]}
      />
      <Container maxW={"7xl"} py={"24px"}>
        <Flex justifyContent="space-between">
          <ButtonGroup variant="outline">
            <Button
              onClick={() => setLocation(`/scenarios/${scenarioId}`)}
              title={intl.formatMessage({
                id: "detailpage.back_to_scenario",
                defaultMessage: "Back to scenario",
              })}
              leftIcon={<ArrowBackIcon />}
            >
              <FormattedMessage
                id="detailpage.back_to_scenario"
                defaultMessage="Back to scenario"
              />
            </Button>
          </ButtonGroup>
          {scenario ? <ActionButtons scenario={scenario} /> : null}
        </Flex>

        {scenario !== null ? (
          <ScenarioRastersMap
            size="l"
            mapId={`scenario-full-map-${scenario.id}`}
            scenario={scenario}
            w="full"
            h="2xl"
            flexShrink="0"
            rounded="lg"
            borderRadius="4px"
            bgColor="white"
            position="relative"
            my="4"
          />
        ) : null}
      </Container>
    </Box>
  );
}
